export default "__VITE_ASSET__143dccca__"